import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/HomePage.css';

const HomePage = () => {
  const { language, t } = useLanguage();
  const location = useLocation();

  const getLocalizedPath = (path) => {
    return `/${language}${path}`;
  };

  return (
    <div className="home-page">
      <section className="hero">
        <div className="hero-content">
          <span className="hero-badge">{t('home.badge')}</span>
          <h1 className="hero-title">
            {t('home.title')} <span className="highlight">{t('home.titleHighlight')}</span>
          </h1>
          <p className="hero-subtitle">
            {t('home.subtitle')}
          </p>
          <div className="hero-buttons">
            <Link to={getLocalizedPath('/products')} className="btn btn-primary">
              {t('home.exploreButton')}
            </Link>
            <Link to={getLocalizedPath('/about')} className="btn btn-secondary">
              {t('home.learnButton')}
            </Link>
          </div>
        </div>
        <div className="hero-gradient"></div>
      </section>

      <section className="features">
        <div className="container">
          <div className="section-header">
            <div className="section-title-wrapper">
              <div className="section-title-accent"></div>
              <h2 className="section-title">{t('home.sectionTitle')}</h2>
              <p className="section-subtitle">{t('home.sectionSubtitle')}</p>
            </div>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <h3>{t('home.feature1Title')}</h3>
              <p>{t('home.feature1Desc')}</p>
            </div>
            <div className="feature-card">
              <h3>{t('home.feature2Title')}</h3>
              <p>{t('home.feature2Desc')}</p>
            </div>
            <div className="feature-card">
              <h3>{t('home.feature3Title')}</h3>
              <p>{t('home.feature3Desc')}</p>
            </div>
            <div className="feature-card">
              <h3>{t('home.feature4Title')}</h3>
              <p>{t('home.feature4Desc')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>{t('home.ctaTitle')}</h2>
          <p>{t('home.ctaDesc')}</p>
          <div className="cta-buttons">
            <Link to={getLocalizedPath('/products')} className="btn btn-primary">
              {t('home.browseProducts')}
            </Link>
            <Link to={getLocalizedPath('/contact')} className="btn btn-outline">
              {t('home.contactUs')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
